import { MaintenanceData } from "./maintenance.run";

export class MaintenanceController {
    public static $inject: string[] = [
        "$scope",
        "maintenanceData",
        "maintenanceService"
    ];

    public message: string;

    constructor(
        $scope,
        maintenanceData: MaintenanceData,
        maintenanceService,
        public sitesService
    ) {
        this.message = maintenanceData.message;

        $scope.$watch(
            () => maintenanceService.data,
            (newValue: MaintenanceData) => {
                if (newValue) {
                    this.message = newValue.message;
                }
            }
        );
    }
}
